import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import {AnimationContents} from '../../../../AnimationContents';
import { GameModel } from '../../../Models/GameModel';
import { GameLogic } from '../../../Logic/GameLogic';
import { ButtonController, IButtonControllerOptions } from '../../../Common/ButtonController';
import { LocalizationContents } from '../../../LocalizationContents';

export interface IFriendsListRowControllerOptions {
    friendName: string;
    embroideryCount: number;
}

export class FriendsListRowController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options: IFriendsListRowControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('FriendsListModalController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.FRIENDS_LIST_MODAL_JSON,
            libraryName: 'friend_row',
            childControllers: {
                btn_gift: {
                    instanceName: "btn_gift", // TODO adjust fla
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        onClick: (status: boolean) => {
                            console.log('Click on get gift')
                            // TODO: add "get gift" method here
                        },
                    },
                },
                btn_ask: {
                    instanceName: "btn_heart", // TODO adjust fla
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        onClick: (status: boolean) => {
                            console.log('Click on ask life')
                            // TODO: add "ask life" method here
                        },
                    },
                },
            },
            modelEvents: {

            },
        };
    }

    protected onInitialize(): void {
        this.friendName = this._options.friendName;
        this.embroideryCount = this._options.embroideryCount;
    }

    protected onResize(width: number, height: number, scale: number) {

    }

    protected onUpdate(frameRate: number) {

    }

    public init(): void {

    }

    public set friendName(value:string) {
        this.setTextByQuery('friend_bio.friend_name', value);
    }

    public get friendName():string {
        return (this.getDisplayObjectByQuery('friend_bio.friend_name')[0] as PIXI.Text).text;
    }

    public set embroideryCount(value:number) {
        this.setTextByQuery('friend_bio.embroidery_count', `${LocalizationContents.getText('Embroideries')}: ${value}`);
    }

    public get embroideryCount():number {
        return +(this.getDisplayObjectByQuery('friend_bio.embroidery_count')[0] as PIXI.Text).text;
    }
}
